import React from "react";
import "./Section.css";

// function htmlify(string) {
//   return <h1 className="heading color">{string}</h1>;
// }

// function color(string, highlights) {
//   let store = [];
//   let words = string.split(" ");
//   for (let i = 0; i < words.length; i++) {
//     // console.log(words[i]);
//     if (words[i] in highlights) {
//       store.push(htmlify(words[i]));
//     } else {
//       store.push(words[i]);
//     }
//   }
//   return <div>{store}</div>;
// }

export default function Section(props) {
  return (
    <React.Fragment>
      <div
        className="main"
        style={{ backgroundColor: props.backgroundColor ?? "" }}
      >
        {props.left === true ? (
          <img
            src={props.image}
            alt={props.alt}
            width={props.width}
            height={props.height}
            style={{
              borderRadius: "50%",
              border: "solid 3px white",
              padding: "3%",
              background: "whitesmoke",
            }}
          />
        ) : null}
        <div className={`text ${props.left ? "left" : "right"}`}>
          <h1>{props.heading ?? "Heading"}</h1>
          {/* <h1>{color(props.heading, props.highlights)}</h1> */}
          <h3>{props.paragraph ?? "Paragraph"}</h3>
        </div>
        {props.left !== true ? (
          <img
            src={props.image}
            alt={props.alt}
            width={props.width}
            height={props.height}
            style={{
              borderRadius: "50%",
              border: "solid 3px white",
              padding: "3%",
              background: "whitesmoke",
            }}
          />
        ) : null}
      </div>
    </React.Fragment>
  );
}

/**
 * For greening:
 * doorstep
 * anywhere, anywhere
 * print
 */
